import React, { useEffect, useRef, useState } from 'react'
import { motion, useInView, animate } from 'motion/react'
import statsVideo from '../../../assets/videos/statsVideo.mp4'

export const statsData = [
  { title: 'متحدث وخبير', value: 80, suffix: '+' },
  { title: 'ساعة إرشادية', value: 50, suffix: '+' },
  { title: 'ورشة عمل وتجارب عملية', value: 20, suffix: '+' },
  { title: 'جهة مشاركة',  value: 20, suffix: '+' },
  { title: 'متطوع ومتطوعة', value: 300, suffix: '+' }
]

function Counter({ value, suffix = '', start }) {
  const [display, setDisplay] = useState(0)

  useEffect(() => {
    if (!start) return
    const controls = animate(0, value, {
      duration: 1.4,
      ease: 'easeOut',
      onUpdate: (v) => setDisplay(Math.floor(v)),
    })
    return () => controls.stop()
  }, [start, value])

  return (
    <span>
      {suffix}
      {display}
    </span>
  )
}

export default function StatsSection() {
  const ref = useRef(null)
  const inView = useInView(ref, { amount: 0.25, once: true })

  const hoverShift = (idx = 0) => {
    const mod = idx % 3
    if (mod === 0) return { x: -6, y: -4 }
    if (mod === 1) return { x: 0, y: -6 }
    return { x: 6, y: -4 }
  }

  return (
    <motion.section
      {...{
        initial: { opacity: 0, y: 40 },
        whileInView: { opacity: 1, y: 0 },
        viewport: { once: true, amount: 0.15 },
        transition: { duration: 0.8, ease: 'easeOut' },
      }}
      className="relative mt-24 h-[520px] sm:h-[600px] overflow-hidden"
    >
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
      >
        <source src={statsVideo} type="video/mp4" />
      </video>

      <div className="absolute inset-0 bg-gradient-to-b from-slate-900/80 via-slate-900/60 to-slate-900/80" />

      <div className="relative z-10 h-full flex items-center" ref={ref}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 w-full">
          <div className="text-center mb-14">
            <h2 className="text-4xl sm:text-5xl font-extrabold text-white">الملتـقى فـي أرقــام</h2>
          </div>

          <div className="grid gap-8 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 text-center">
            {statsData.map((item, index) => (
              <motion.div
                key={item.title}
                whileHover={{ scale: 1.06, ...hoverShift(index) }}
                transition={{ type: 'spring', stiffness: 240, damping: 20 }}
              >
                <p className="text-4xl sm:text-5xl font-extrabold text-sky-300 mb-2">
                  <Counter value={item.value} suffix={item.suffix} start={inView} />
                </p>
                <p className="text-lg font-semibold text-white">{item.title}</p>
                {item.subTitle && (
                  <p className="text-lg font-semibold text-white">{item.subTitle}</p>
                )}
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </motion.section>
  )
}